module.exports = __webpack_public_path__ + "img/trial1-1.326b7622.png";